import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const messageListener = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    boundaryEventId: z
      .string()
      .describe('The boundary event that created this listener'),

    messageName: z
      .string()
      .nullable()
      .optional()
      .describe('Name of the message being waited for'),

    interrupting: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this boundary event cancels the parent activity'),

    status: z
      .enum(['Active', 'Paused', 'Triggered', 'Complete', 'Canceled'])
      .nullable()
      .optional()
      .describe('Current state of this listener'),

    completedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When the message was received'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    tokenId: z.uuid().hidden().describe('Foreign key to Token'),

    token: belongsTo('Token'),
  })
  .describe('Waits for a specific message to arrive')
  .as('MessageListener');

export { messageListener as messageListenerSchema };
